import React from 'react';
import {DatePickerHeaderMobile} from './components/DatePickerHeaderMobile';
import {DatePickerHeaderProps} from './DatePickerHeader.types';
import {DatePickerHeaderDesktop} from './components/DatePickerHeaderDesktop';

const DatePickerHeader: React.FC<DatePickerHeaderProps> = ({
	month,
	year,
	lang,
	showNextMonth,
	onPrevMonth,
	onNextMonth,
	disableButtonPrevMonth,
	disableButtonNextMonth,
}) => {
	const currentMonth = new Date().getMonth() + 1;
	const currentYear = new Date().getFullYear();

	const isCurrentMonth = month ? currentMonth === month && year === currentYear : false;

	const disableChangeMonth = (disableButtonChangeMonth?: boolean) =>
		disableButtonChangeMonth ? isCurrentMonth : false;

	return showNextMonth ? (
		<DatePickerHeaderDesktop
			onNextMonth={onNextMonth}
			onPrevMonth={onPrevMonth}
			disableButtonPrevMonth={disableChangeMonth(disableButtonPrevMonth)}
			disableButtonNextMonth={disableChangeMonth(disableButtonNextMonth)}
		/>
	) : (
		<DatePickerHeaderMobile
			year={year}
			month={month}
			disableButtonPrevMonth={disableChangeMonth(disableButtonPrevMonth)}
			disableButtonNextMonth={disableChangeMonth(disableButtonNextMonth)}
			onNextMonth={onNextMonth}
			onPrevMonth={onPrevMonth}
			lang={lang}
		/>
	);
};

export {DatePickerHeader};
